export default __webpack_public_path__ + "b99afddc6acaa8a43600648322a7867d.png";